import { useEffect, useState } from 'react';
import '../assets/css/dialog.css';
import seleccionador from '../assets/img/gif/_seleccionador.gif'
import progress from '../assets/img/gif/progres.gif'





function Dialog(props) {
     function close(){
        document.getElementsByClassName("dialog")[0].remove();
    }
    useEffect(() => {

    });
    return (
        <div class="dialog">

            <div>
                <img class="img-seleccionador img-responsive" src={seleccionador}></img>
            </div>
            <div class="globo">
                <div style={{ textAlign: "end",padding:10 }}><i class="fas fa-times-circle" onClick={close}></i ></div>
                <p id="mensaje"></p>
            </div>
        </div>
    );
}

export default Dialog;